import React, { useState } from 'react'
import Tippy from '@tippyjs/react';
import {Link} from 'react-router-dom'

const Items = ({items, departmentId ,showFileModal,title, showKey ,showFiles ,openFileModalForPersonalItems ,viewSinglePersonalItem}) => {
    var numbering = 0

    const [currentPage, SetCurrentPage] = useState(1)
    const [postPerPage, SetPostPerPage] = useState(10)

    const indexOfLastItem = currentPage * postPerPage
    const indexOfFirstItem = indexOfLastItem - postPerPage
    const CurrentItems = items.slice(indexOfFirstItem, indexOfLastItem)

    const nextButton = () => {
        if (indexOfLastItem < items.length) {
            SetCurrentPage(currentPage + 1)
        }
    }

    const prevButton = () => {
        if (currentPage !== 1) {
            SetCurrentPage(currentPage - 1)
        }
    }
    const itemNumber = (n) =>{
        const pageNum= (currentPage-1) * postPerPage
        return n + pageNum 
    }
    console.log(items)
    return (
        <div className="overflow-auto max-h-full">
                        <table className="divide-y text-sm mt-4  border-b border-gray-200 divide-gray-200">
                                        <thead>
                                            <tr className="text-gray-500">
                                            <th className="  px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                                                    #
                                                </th>
                                                <th className="  px-4 py-4 whitespace-nowrap  text-sm font-medium  ">
                                                    Names
                                                </th>
                                                <th className="  px-4 py-4 whitespace-nowrap  text-sm font-medium  ">
                                                    Staff ID
                                                </th>
                                                <th scope="col" className="  px-4 py-4 whitespace-nowrap  text-sm font-medium  ">
                                                    Position
                                                </th>
                                                <th scope="col" className="  px-4 py-4 whitespace-nowrap  text-sm font-medium  ">
                                                Status
                                                </th>
                                                <th scope="col" className="  px-4 py-4 whitespace-nowrap  text-sm font-medium  ">
                                                Date of Joining
                                                </th>
                                                <th scope="col" className="  px-4 py-4 whitespace-nowrap  text-sm font-medium  ">
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {CurrentItems.map(item => {
                                                  numbering += 1
                                                return (
                                                    <React.Fragment>
                                                        <tr key={item.id}  className="divide-y cursor-pointer hover:bg-gray-100 border-b border-gray-200 divide-gray-200">
                                                        <td className="px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                                                        <span className="text-sm text-left">{itemNumber(numbering)}</span>
                                                                </td>
                                                            <td className="px-8 py-4 whitespace-nowrap text-center text-sm font-medium">{item.names} </td>
                                                            <td className="px-8 py-4 whitespace-nowrap text-center text-sm font-medium">{item.staff_id} </td>
                                                            <td className="px-8 py-4 whitespace-nowrap text-center text-sm font-medium">{item.position} </td>
                                                            <td className= "px-8 py-3 whitespace-nowrap text-center text-sm font-medium">{item.status} </td>
                                                            <td className="px-8 py-4 whitespace-nowrap text-center text-sm font-medium">{item.date_of_joining ? new Date(item.date_of_joining).toDateString() : ""}</td>
                                                            <td className="px-8 py-4 whitespace-nowrap text-center text-sm font-medium">
                                                                 <Link className="bg-wvrOrange text-white p-1 rounded-md ml-2" to={`/collections/items/${departmentId}/${item.id}/viewFiles`}>
                                                                    <span className="ml-2 mr-2">
                                                                        View Files
                                                                    </span>
                                                                </Link>
                                                                <Link className="bg-wvrOrange text-white p-1 rounded-md ml-2" to={`/collections/items/${departmentId}/${title}/${item.id}/editItem`}>
                                                                    <span className="ml-2 mr-2">
                                                                     Edit Item
                                                                    </span>
                                                                </Link>
                                                                <button onClick={() =>viewSinglePersonalItem(item)} 
                                                                className="bg-wvrOrange text-white p-1 rounded-md ml-2">
                                                                   <span className="ml-2 mr-2">
                                                                     More
                                                                   </span>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>
                                                )
                                            })}
                                        </tbody>
                                    </table>



            <div className="my-4 mr-4">
                <ul className="flex flex-row gap-4 justify-end">
                    <li className="bg-wvrOrange text-white px-2 py-1 rounded-lg cursor-pointer" onClick={() => prevButton()}>
                        <div >Prev</div>
                    </li>
                    <li className="py-1">{currentPage}</li>
                    <li onClick={() => nextButton()} className="bg-wvrOrange text-white px-2 py-1 rounded-lg cursor-pointer">
                        <div >Next</div>
                    </li>
                </ul>
            </div>
        </div>
    )
}
export default Items
